import request from '@/api/request'

// 下载模板
export function importTemplate() {
  return request({
    url: `/system/model/importTemplate`,
    method: 'post',
    responseType: 'blob'
  })
}

// 获取系统模型列表
export function listSystemModel(params) {
  return request({
    url: `/system/model/list`,
    method: 'get',
    params
  })
}

// 获取系统模型下拉选项
export function getSystemModelList() {
  return request({
    url: `/system/model/list/item`,
    method: 'get'
  })
}

// 获取系统模型数据
export function getSystemModel(id) {
  return request({
    url: `/system/model/${id}`,
    method: 'get'
  })
}

// 新增系统模型
export function addSystemModel(data) {
  return request({
    url: `/system/model/edit`,
    method: 'post',
    data: data
  })
}

// 更新系统模型
export function updateSystemModel(data) {
  return request({
    url: `/system/model/edit`,
    method: 'put',
    data: data
  })
}

// 删除系统模型
export function deleteSystemModel(id) {
  return request({
    url: `/system/model/edit/${id}`,
    method: 'delete'
  })
}
